import { Tooltip } from "../components/Tooltip";
import { cn } from "../lib/utils";
import React from "react";
/**
 * Clamps text to a number of lines and, only when the text is actually cut off, wraps it
 * in a `Tooltip` revealing the full content on hover. Use it for labels or descriptions
 * that may overflow their container; for collapsing tall rich content behind a
 * show-more toggle, use `TruncatedContent` instead.
 *
 * @summary Line-clamped text with overflow tooltip.
 */
export const TruncatedText = ({
  children,
  className,
  lineClamp = 2,
  mountPortal,
  mountPortalContainer,
  ...props
}) => {
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);

  // Check if content is actually truncated by comparing scroll height to
  // client height
  // This ensures we only show the tooltip when text is cut off by line-clamp-
  // oxlint-disable-next-line react/exhaustive-deps -- not reported by the previous linter; deps kept as-is
  React.useLayoutEffect(() => {
    const element = textRef.current;
    if (element) {
      const isOverflowing = element.scrollHeight > element.clientHeight;
      setIsTruncated(isOverflowing);
    }
  });
  const textElement = /*#__PURE__*/React.createElement("div", {
    ref: textRef,
    className: cn(`line-clamp-${lineClamp} cursor-pointer select-none`, className),
    style: {
      maxHeight: `calc(1lh * ${lineClamp})`
    },
    ...props
  }, children);
  if (isTruncated) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      trigger: textElement,
      label: children,
      tooltipTriggerAsChild: true,
      mountPortal: mountPortal,
      mountPortalContainer: mountPortalContainer
    });
  }
  return textElement;
};
//# sourceMappingURL=TruncatedText.js.map